// extracted by mini-css-extract-plugin
export default {"wrapper":"AgreementItem_wrapper__lYGYe","container":"AgreementItem_container__B-vB4"};